export function formatHourDecimalToTimeString(
  value: number,
  offset: number,
): string {
  const decimalHour = (value + offset) % 24;
  const hours = Math.floor(decimalHour);
  const minutes = Math.round((decimalHour - hours) * 60);
  const paddedHours = String(hours).padStart(2, '0');
  const paddedMinutes = String(minutes).padStart(2, '0');
  return `${paddedHours}:${paddedMinutes}`;
}
